import { QueryParams } from "../types/types";
import { format } from 'date-fns'

// todo fix this function
const convertDate = (date: string | null): Date | undefined  => {
  return date !== null ? new Date(date) : undefined;
};

export const queryParams = (): QueryParams | undefined  => {
  const params = new URLSearchParams(window.location.search);
  const checkId =
    params.get("id") !== null ? Number(params.get("id")) : undefined;
  const token = params.get("token") || undefined;
  const date = convertDate(params.get("ts"));
  const location = params.get("location") || undefined;
  if( checkId === undefined || token === undefined || date === undefined || location === undefined) {
    return undefined;
  }
    else {
      return {
        checkId,
        location,
        token,
        date,
      };
    }
};

/**
 * converts a string to hex value
 * @param an arbitrary string that will be converted to hex
 * @returns hex value of the string
 */
export const color = (str: string): string => {
  const hash = str.split("").reduce((a, b) => {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);
  return `#${Math.abs(hash).toString(16)}`;
};

// use Intl.NumberFormat to format numbers with style
export const formatNumber = (
  num: number,
  style: string = "decimal"
): string => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: style,
    maximumFractionDigits: 2,
  });
  return formatter.format(num);
};


export const formatDate = (date: Date) => {
  return format(date, "	EEEEEE, dd LLLL yyyy HH:mm:ss");
};

export const formatDateFromString = (date: string) => {
  return formatDate( new Date(date));
};

export const minutesToHumanReadable = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  const minutesRemainder = minutes % 60;
  return `${hours}h ${minutesRemainder}m`;
};